import { useState, useEffect } from 'react';
import { ActionsConfigs } from 'common/visualizations/views/agGridReact/ProcessDiscoveryButton/types';

interface ExtraParams {
  showAllActions?: boolean;
  isBatchFetch?: boolean;
  primaryValues?: string;
}

interface FetchProcessDisconveryParams {
  contextParams: ActionsConfigs | object;
  extraParams?: ExtraParams;
}

export const fetchProcessDiscoveryData = async ({
  contextParams,
  extraParams,
}: FetchProcessDisconveryParams) => {
  const url = '/process_discovery/actions';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...contextParams, ...extraParams }),
  });
  if (!response.ok) {
    return { errorCode: response.status, message: 'Failed to fetch process discovery results' };
  }

  const data = await response.json();
  return data?.results;
};

export const useProcessDiscoveryResults = (
  contextParams: ActionsConfigs | object,
  extraParams?: ExtraParams,
) => {
  const { mappedColumns } = contextParams as ActionsConfigs;
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const fetchProcessDiscoveryResults = async () => {
    try {
      if (mappedColumns && mappedColumns.length > 0) {
        setLoading(true);

        const processDiscoveryData = await fetchProcessDiscoveryData({
          contextParams,
          extraParams,
        });

        setResults(processDiscoveryData || {});
      } else {
        setResults({});
      }
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProcessDiscoveryResults();
  }, [mappedColumns]);

  return { processDiscoveryResults: results, loading, error };
};
